<template>
    <div>
      <div>
        <div class="container">
          <router-view :key="$route.fullPath"></router-view>
        </div>
      </div>   
    </div>
  </template>
  <script>
    
    export default {
      name: 'plainLayout'     
    }
  </script>
